import { ExpandableBtn } from "./expandable-btn";

export const Category = ({ category, classification, table = false }) => {
    if (!classification) {
        return (<>{category}</>);
    }

    return (
        <div className="flex flex-row text-start items-center gap-2" >
            <ExpandableBtn 
                label="i"
                ariaLabel={`${classification}`} 
                context={`履修上の区分: ${classification}`}
            />
            {category}
        </div>
    );
};